/** ISO 4217 fallback when tenant has no billing default yet */
export const DEFAULT_BILLING_CURRENCY = "USD";

/** Common billing currencies for tenant default / gateway settings pickers */
export const BILLING_CURRENCY_OPTIONS = [
  "USD",
  "EUR",
  "ZAR",
  "GBP",
  "KES",
  "NGN",
] as const;

export function formatMoney(
  amount: number,
  currency: string = DEFAULT_BILLING_CURRENCY,
  locale: string | string[] | undefined = undefined,
): string {
  const code =
    typeof currency === "string" && currency.length >= 3
      ? currency.slice(0, 3).toUpperCase()
      : DEFAULT_BILLING_CURRENCY;
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
    }).format(amount);
  } catch {
    return `${code} ${amount.toFixed(2)}`;
  }
}
